export default {
  name: "Credit",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 4H4c-1.16 0-2 .84-2 2v20c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V6c0-1.16-.84-2-2-2zm0 2 .01 4.5H4V6h24zm0 20H4V14.5h24.02l.03 11.5H28zm-3-5c0 .55-.45 1-1 1h-4.5c-.55 0-1-.45-1-1s.45-1 1-1H24c.55 0 1 .45 1 1z",
  },
}
